import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { municipioPodeAcessarConvocacao } from "../config/municipiosConvocacao";

const ConvocacaoMunicipioGuard = ({ children }) => {
  const acessoAtivo = useSelector((state) => state.access.acessoAtivo);

  if (!municipioPodeAcessarConvocacao(acessoAtivo)) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="alert alert-warning" role="alert">
            Esta funcionalidade está disponível apenas para os municípios selecionados
            para o período de testes.
          </div>
        </div>
      </div>
    );
  }

  return children;
};

ConvocacaoMunicipioGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ConvocacaoMunicipioGuard;
